// extracted by mini-css-extract-plugin
export default {"col-right":"home_col-right__5v9In","homePageDescriptions":"home_homePageDescriptions__Dy-9F"};